import type { ViewState } from "../../types/warehouse.types";
import type { PlaceColumn } from "../core/types";

/**
 * Sorts columns by depth for Painter's Algorithm
 */
export class ColumnSorter {
  private lastRotation = -999;
  private lastColumns: PlaceColumn[] | null = null;
  private readonly ROTATION_THRESHOLD = 0.01;

  /**
   * Sort columns by depth, caching result when rotation and array unchanged
   */
  sort(columns: PlaceColumn[], viewState: ViewState): PlaceColumn[] {
    if (
      Math.abs(viewState.rotation - this.lastRotation) < this.ROTATION_THRESHOLD &&
      this.lastColumns === columns
    ) {
      return columns;
    }

    const sinRot = Math.sin(viewState.rotation);
    const cosRot = Math.cos(viewState.rotation);

    for (let i = 0; i < columns.length; i++) {
      const col = columns[i];
      col.depth = col.baseX * sinRot + col.baseY * cosRot;
    }

    columns.sort((a, b) => a.depth - b.depth);

    this.lastRotation = viewState.rotation;
    this.lastColumns = columns;

    return columns;
  }
}
